var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.tooltipContent }),expression:"{ content: tooltipContent }",modifiers:{"bottom":true}}],style:({ color: _vm.isRejected ? 'red' : 'inherit' })},[_vm._v("\n    "+_vm._s(_vm.displayValue)+"\n    "),(_vm.isRejected)?_c('i',{staticClass:"fas fa-info-circle"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168e3ce3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-cards/CardStatus.vue
// module id = 5cYz
// module chunks = 12